<template>
  <div class="auth__wrap">
    <div class="auth__container">
      <WelcomeStep v-if="step === 'welcome'" @login="step = 'phone'" />
      <PhoneStep
        v-else-if="step === 'phone'"
        :is-wrong-phone="isWrongPhone"
        @back="step = 'welcome'"
        @submit="handlePhoneSubmit"
        :isWrongPhone="isWrongPhone"
        :isLoadingBtn="isLoadingRequestOtp"
      />
      <CodeStep
        v-else-if="step === 'code'"
        ref="codeStepRef"
        :phone="phone"
        :error-count="errorCodeCount"
        @back="step = 'phone'"
        @submit="handleCodeSubmit"
        @resend="handleResendCode"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import WelcomeStep from "@/components/auth/WelcomeStep.vue";
import PhoneStep from "@/components/auth/PhoneStep.vue";
import CodeStep from "@/components/auth/CodeStep.vue";
import { getPhoneNumber, getTokenFromCookies } from "@/utils/common";
import { useStore } from "@/store";

const { t } = useI18n();

const store = useStore();
const router = useRouter();

const step = ref<"welcome" | "phone" | "code">("welcome");
const phone = ref("");
const isWrongPhone = ref(false);
const isLoadingRequestOtp = ref(false);
const errorCodeCount = ref(0);

const handlePhoneSubmit = async (submittedPhone: string) => {
  phone.value = getPhoneNumber(submittedPhone);
  isLoadingRequestOtp.value = true;
  store
    .dispatch("auth/requestOtp", {
      msisdn: phone.value,
    })
    .then((response) => {
      if (!response) return;
      if (response.data?.status) {
        isWrongPhone.value = false;
        step.value = "code";
      } else {
        isWrongPhone.value = true;
      }
    })
    .catch(() => {
      //TODO: в модалку перененсти? в стор
      alert(t("auth.errors.service"));
    })
    .finally(() => {
      isLoadingRequestOtp.value = false;
    });
};

const handleCodeSubmit = async (code: string) => {
  store
    .dispatch("auth/verifyOtp", {
      msisdn: phone.value,
      code,
    })
    .then((data) => {
      if (!data) return;
      if (data.status) router.push("/account");
      else errorCodeCount.value++;
    })
    .catch(() => {
      //TODO: перенсти в стор
      alert(t("auth.errors.service"));
    });
};

const handleResendCode = () => {
  handlePhoneSubmit(phone.value);
};

watch(step, (newStep) => {
  store.dispatch(
    "system/updateLogoVisibility",
    ["phone", "code", "welcome"].includes(newStep)
  );
});

onMounted(() => {
  if (getTokenFromCookies()) {
    store.dispatch("auth/setAuth", true);
    router.push("/account");
  }

  if (step.value === "welcome") {
    store.dispatch("system/updateLogoVisibility", true);
  }
});

onBeforeUnmount(() => {
  store.dispatch("system/updateLogoVisibility", false);
});
</script>

<style scoped lang="scss">
@import "@/assets/style/main";

.auth {
  &__wrap {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;

    @media (max-width: 768px) {
      height: var(--app-height);
      max-height: var(--app-height);
      align-items: stretch;
    }
  }

  &__container {
    display: flex;
    justify-content: center;
    min-height: 537px;
    width: 392px;
    margin: 0;

    @media (max-width: 768px) {
      width: 100%;
      min-height: 0;
      height: 100%;
      max-height: 100%;
      margin: 0;
    }
  }
}
</style>
